export default function StaticExcelViewer({ fileUrl }: { fileUrl: string }) {
  return (
    <iframe
      src={fileUrl}
      title="Spreadsheet preview"
      style={{ width: '100%', height: '100%', border: 0 }}
    />
  )
}
